import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import { isDemoWhitelabelSubdomain, offersAllowedAgentIds } from "constants/index";
import filterRecentlyVisitedForWhitelabel from "@Utils/whitelabelHelper";

const useWhitelabel = () => {
  const whitelabelState = useSelector(
    ({ whitelabelData }: AppState) => ({
      whitelabelConfig: whitelabelData.config,
      isWhitelabel: whitelabelData.isWhitelabel,
      whitelabel_region_canonical_name: whitelabelData.whitelabel_region_canonical_name,
      subdomain: whitelabelData.subdomain,
      partner_id: whitelabelData.partner_id,
      partner_uuid: whitelabelData.partner_uuid,
      partnerName: whitelabelData.partner_name,
      whitelabelColors: whitelabelData.colors,
      universityMock: whitelabelData.university_mock,
      isDemoSubdomain:
        whitelabelData.isWhitelabel && isDemoWhitelabelSubdomain(whitelabelData.subdomain),
      regionCanonicalNames: whitelabelData.region_canonical_names,
      requestDetails: whitelabelData.requestDetails,
      isUniversityPartner: whitelabelData.isUniversityPartner,
      isWhitelabelDataFetched: whitelabelData.isWhitelabelDataFetched,
      isGlobalSearchEnabled: whitelabelData?.config?.is_global_search_enabled,
      citiesList: whitelabelData?.cities_list,
      universitiesList: whitelabelData?.universities_list,
      countryWiseCityData: whitelabelData?.countryWiseCityData,
      countryWiseUniversityData: whitelabelData?.countryWiseUniversityData,
      isReferralCardEnabled: whitelabelData?.config?.is_referral_card_enabled,
      isLocationSearchRestricted:
        whitelabelData?.isWhitelabel &&
        (whitelabelData?.isUniversityPartner || !whitelabelData?.config?.is_global_search_enabled),
      isRestrictedSearchEnabled:
        whitelabelData.isWhitelabel &&
        !whitelabelData.isUniversityPartner &&
        !whitelabelData?.config?.is_global_search_enabled,
      whitelabelTheme: whitelabelData?.themes,
      isAnnouncementBannersEnabled: whitelabelData?.config?.is_announcement_banner_enabled,
      announcementBanners: whitelabelData?.config?.announcement_banners,
      partnerType: whitelabelData?.partnerType,
      isPartnerCustomFormEnabled: whitelabelData?.isPartnerCustomFormEnabled,
      isCustomFormForAllInventories: whitelabelData?.isCustomFormForAllInventories,
      partnerCustomFormFieldConfig: whitelabelData?.partnerCustomFormFieldConfig,
      isUSAPartner: whitelabelData?.isUSAPartner,
      isWhitelabelSeoEnabled: whitelabelData?.isWhitelabelSeoEnabled,
      whitelabelGoogleSiteVerificationId: whitelabelData?.whitelabelGoogleSiteVerificationId,
      isPoweredByAmberEnabledForWhitelabelFooter:
        whitelabelData?.isPoweredByAmberEnabledForWhitelabelFooter,
      agentId: whitelabelData?.agentId,
      isSubPartnerRedirectToWhitelabel: whitelabelData?.isSubPartnerRedirectToWhitelabel,
    }),
    shallowEqual,
  );

  const getFilteredRecentlyVisited = () => {
    const stored = JSON.parse(localStorage.getItem("recentlyVisited") ?? "[]") || [];
    return stored.length > 0
      ? filterRecentlyVisitedForWhitelabel(
          stored,
          whitelabelState.isWhitelabel,
          whitelabelState.partner_id,
        )
      : [];
  };

  const isAllowedEmail = offersAllowedAgentIds.includes(whitelabelState.agentId);

  return {
    ...whitelabelState,
    isAllowedEmail,
    getFilteredRecentlyVisited,
  };
};

export default useWhitelabel;
